import Input from "./Input";
import RadioGroup from "./RadioGroup";
import Select from "./Select";
import Checkbox from "./Checkbox";
import Button from "./Button";
import ActionButton from "./ActionButton.js";

const Controls = { 
    Input,
    RadioGroup,
    Select,
    Checkbox,
    Button,
    ActionButton
}

export default Controls;